"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const ErrorResponse_1 = __importDefault(require("./ErrorResponse"));
const Serializer_1 = require("../../../Serializer");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class ErrorResponseSerializerV2 extends Serializer_1.Serializer {
    toArray(errorResponse) {
        return [
            VERSION,
            ControlMessage_1.default.TYPES.ErrorResponse,
            errorResponse.requestId,
            errorResponse.errorMessage,
            errorResponse.errorCode,
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, errorMessage, errorCode,] = arr;
        return new ErrorResponse_1.default({
            version, requestId, errorMessage, errorCode
        });
    }
}
exports.default = ErrorResponseSerializerV2;
ControlMessage_1.default.registerSerializer(VERSION, ControlMessage_1.default.TYPES.ErrorResponse, new ErrorResponseSerializerV2());
//# sourceMappingURL=ErrorResponseSerializerV2.js.map